import { decryptData, encryptData } from 'helpers/Encrypth.js';
import { useState } from 'react';

export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = decryptData(localStorage.getItem(keyName));
      if (value) {
        return JSON.parse(value);
      } else {
        localStorage.setItem(
          keyName,
          encryptData(JSON.stringify(defaultValue))
        );
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });
  const setValue = newValue => {
    localStorage.setItem(keyName, encryptData(JSON.stringify(newValue)));

    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};
